/**
 * 画面に出すサービス名（表示名）の 1 か所（founder の決定 2026-09-30「KUMODeck」・旧 2026-09-29「XKumo」・旧 2026-09-28「KUMO X」・MASTER-PLAN）。
 * 2026-09-30 の改名の WHY: xkumo.com が第三者の持ち物で「ブランド名.com」にできないため（docs/research/2026-09-30-name-dotcom.md）。
 * 辞書（i18n の en / ja・お金の辞書も）には名前を直接書かず `{product}` と書く。translate / translateRich が自動で埋める（i18n/index.ts）。
 * WHY ビルドの env で変えられるか: 表記が後で変わっても 1 か所で済むように（サーバーは KUMO_PRODUCT_NAME・Core c9e63576 と同じ既定）。
 * 変えないもの: パッケージ名 `@kumo/*`・kumo.config.json・KUMO_* の env・コードの識別子・URL のパス。
 * コマンド名（kumodeck）は別の 1 か所 cliCommand.ts の CLI_NAME（辞書では `{cliName}`）= 表示名と一緒には変えない。
 * node の --test では import.meta.env が無い（vite の外）= 既定の値
 */
export const DEFAULT_PRODUCT_NAME = 'KUMODeck';

/**
 * env の値 → 表示名（空・文字列でない = 既定・前後の空白を外す・40 文字まで = サーバーの KUMO_PRODUCT_NAME と同じ規則）。
 * WHY 関数にしたか: vite.config.ts（index.html の <title> を埋める）も同じ規則で読むため。import.meta.env は vite の設定の中には無い
 */
export function productNameFrom(raw: unknown): string {
  return typeof raw === 'string' && raw.trim() ? raw.trim().slice(0, 40) : DEFAULT_PRODUCT_NAME;
}

/**
 * 「KUMODeck でログイン」の provider の識別子（2026-10-07 core/kumodeck-signin）。サーバー・SDK・kumo.config.json の auth.providers の名前で、
 * 表示名ではない（サービス名が変わっても変えない）。名前を持ってよい 1 か所（wording.test.ts の onePlace）に置く
 */
export const ACCOUNT_SIGNIN_PROVIDER = 'kumodeck' as const;

export const PRODUCT_NAME: string = productNameFrom((import.meta as { env?: Record<string, unknown> }).env?.VITE_KUMO_PRODUCT_NAME);

/**
 * 検証用の MCP（mcp-staging）の名前の番号（2026-10-15 console/preview-name・founder 10/15）。許可の画面の見出し・バッジに
 * 「KUMODeck Preview (v0.2)」と出す（辞書では `{preview}`・i18n/index.ts が自動で埋める）。
 * WHY: 以前は「KUMODeck staging」「KUMODeck 先取り」と出ていた → founder「これはよくないね。バージョン〇〇プレビュー版みたいな」。
 *   番号は管理が決めた次の版（今の公開の版が 0.1 系 = 0.2 の先取り）。次に進んだら（例 'v0.3'）ここと MCP の
 *   apps/mcp/src/productName.ts PREVIEW_VERSION を一緒に変える（MCP が Claude / ChatGPT の一覧に名乗る名前。同じ値かは previewName.test.ts が確かめる）。
 * 日本語にしない: Academy の YouTube は画面に日本語を出さない決まり = ja の画面でもこの名前は英語のまま
 */
export const PREVIEW_VERSION = 'v0.2';
export const PREVIEW_NAME: string = `${PRODUCT_NAME} Preview (${PREVIEW_VERSION})`;

/**
 * index.html の <title> を表示名で埋める（vite.config.ts の transformIndexHtml から・開発とビルドの両方）。
 * WHY: 画面が描かれるまでの一瞬とタブの名前にも表示名を出す（描いた後は i18n/index.ts の applyDocument が app.title で上書き・言語つき）。
 * index.html には既定の名前で書いてある = このプラグインが無くても壊れない。名前は HTML に入るので < > & " をエスケープする
 */
export function injectProductTitle(html: string, name: string): string {
  const esc = name.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]!);
  return html.replace(/<title>[^<]*<\/title>/, `<title>${esc} dashboard</title>`);
}
